import React, { forwardRef, useMemo } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const CarouselSection = forwardRef(
  (
    {
      children,
      id = '',
      backgroundColor = '',
      className = '',
      header,
      subheader,
      footer,
      beforeChange,
      onReInit
    },
    ref
  ) => {
    const slides = useMemo(() => {
      return 4 <= children.length
        ? children
        : Array.from({ length: 4 }, (_, i) => children[i] !== undefined ? children[i] : (<div key={i}></div>));
    });

    return (
      <section id={id} className={classnames(className, backgroundColor)}>
        <div className="ps-container-fixed ps-container-lg-margin">
          <div className="ps-row">
            {!!header && (
              <div
                data-testing-id="ps-carousel-section-header"
                className='col-xs-12'
              >
                {header}
              </div>
            )}
            {!!subheader && (
              <div
                data-testing-id="ps-carousel-section-subheader"
                className='col-xs-12'
              >
                {subheader}
              </div>
            )}
            <Slider
              className="CarouselSection"
              slidesToShow={3}
              slidesToScroll={1}
              speed={500}
              infinite={false}
              swipeToSlide={false}
              draggable={false}
              swipe={false}
              arrows={false}
              lazyLoad='progressive'
              beforeChange={(oldIndex, newIndex) => { beforeChange(oldIndex, newIndex, children.length); }}
              onReInit={() => { onReInit(children.length); }}
              responsive={[
                {
                  breakpoint: 1441,
                  settings: {
                    centerMode: true,
                    centerPadding: '144px'
                  }
                },
                {
                  breakpoint: 1199,
                  settings: {
                    centerMode: true,
                    centerPadding: '30px'
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    centerPadding: '30px'
                  }
                },
                {
                  breakpoint: 575,
                  settings: {
                    slidesToShow: 1.5,
                    centerMode: true,
                    centerPadding: '9px'
                  }
                },
                {
                  breakpoint: 427,
                  settings: {
                    slidesToShow: 1.1,
                    centerMode: true,
                    centerPadding: '9px'
                  }
                }
              ]}
              ref={ref}
            >
              {slides}
            </Slider>
            {!!footer && (
              <div
                data-testing-id="ps-carousel-section-footer"
                className='col-xs-12'
              >
                {footer}
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
);

CarouselSection.displayName = 'CarouselSection';
CarouselSection.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  backgroundColor: PropTypes.string,
  header: PropTypes.node,
  subheader: PropTypes.node,
  footer: PropTypes.node,
  beforeChange: PropTypes.func,
  onReInit: PropTypes.func
};
